import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=5a406c03&scoped=true&"
import script from "./ViewDetails.vue?vue&type=script&lang=js&"
export * from "./ViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetails.vue?vue&type=style&index=0&id=5a406c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a406c03",
  null
  
)

export default component.exports